import TrainingsPage from './TrainingsPage'

export default TrainingsPage
